import React from 'react';

import { colors } from '@/globalStyles';

const ImageContrast = props => {
  const { isActive } = props;
  return isActive ? (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 15.625c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10zm10 9v-18a9 9 0 1 1 0 18z" fill={colors.primary} />
    </svg>
  ) : (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 15.625c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10zm10 9v-18a9 9 0 1 1 0 18z" fill={colors.black} />
    </svg>
  );
};

export default ImageContrast;
